import { api } from "@/plugins/api";

const state = {
  settings: [],
};

const getters = {
  getAllSettings: (state) => state.settings,

  getSettingById: (state) => (id) =>
    state.settings.filter((setting) => setting.id === id),
};

const actions = {
  async fetchAllSettings({ commit }) {
    try {
      const response = await api.get("/settings");
      const settings = response.data.data;
      commit("setSettings", settings);
      return true;
    } catch (error) {
      return false;
    }
  },
  async updateSetting({ commit }, setting) {
    try {
      const id = setting.id;
      setting._method = "put";
      const response = await api.post(`/settings/${id}`, setting);
      console.log("updated", response.data);
      commit("updateSetting", response.data.data);
      return true;
    } catch (error) {
      return false;
    }
  },
};

const mutations = {
  setSettings(state, settings) {
    state.settings = settings;
  },

  updateSetting(state, setting) {
    const id = setting.id;
    const index = state.settings.findIndex((setting) => setting.id == id);
    if (index !== -1) {
      state.settings[index] = setting;
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
